import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ValidationsService } from '@app/core/services/validations.service';
import { Constants } from '@app/shared/class/constants.class';
import { AppConfig } from '@config/app.config';
import { AccountingService } from '@core/services/accounting.service';
import { GeneralsService } from '@core/services/generals.service';
import * as moment from 'moment';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-transactions-events-download',
  templateUrl: './transactions-events-download.component.html'
})
export class TransactionsEventsDownloadComponent implements OnInit, OnDestroy {
  public constants = new Constants();

  public transactionForm: FormGroup;
  public minDate = moment().subtract(90, 'days');
  public maxDate = moment();

  constructor(
    public appConfig: AppConfig,
    public accountingService: AccountingService,
    public generalsService: GeneralsService
  ) {}

  ngOnInit() {
    this.transactionForm = new FormGroup(
      {
        dateStart: new FormControl('', [
          Validators.required,
          ValidationsService.isDateBetweenNinetyDaysFromToday
        ]),
        dateEnd: new FormControl('', [
          Validators.required,
          ValidationsService.isDateBetweenNinetyDaysFromToday
        ])
      },
      [ValidationsService.validateRangeDateValue]
    );
  }

  ngOnDestroy() {
    this.constants.destroy$.next(true);
    this.constants.destroy$.unsubscribe();
  }

  onSubmit() {
    const form = this.transactionForm;
    if (form.dirty && form.valid) {
      const loading = this.generalsService.loading();
      this.accountingService
        .downloadTransactionsEvents(form)
        .pipe(takeUntil(this.constants.destroy$))
        .subscribe(
          result => {
            const fileName = this.generalsService.getFileName(
              result.headers.get('content-disposition')
            );
            this.generalsService.download(fileName, 'csv', result);
            loading.close();
          },
          error => {
            loading.close();
            this.generalsService.notification(
              this.appConfig.NOTIFICATION.error,
              this.generalsService.showError(error)
            );
          }
        );
    }
  }
}
